// PhonicsLt12.js
// 包装组件：Letter Teams L12
// 路由：/phonics/lt12
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt12 } from './phonics/phonics_data_lt12';

function PhonicsLt12() {
  return <PhonicsLt letterData={letterDataLt12} />;
}

export default PhonicsLt12;
